const NOTIFY_DURATION = 15000
export const NOTIFY_ANIMATION_DURATION = 500
export const STATUS_ERROR = 'error'
export const STATUS_MESSAGE = 'message'
export const STATUS_WARNING = 'warning'
export const STATUS_SUCCESS = 'success'

export default {
  actions: {
    actionPushNotificationMessage(ctx, message) {
      ctx.dispatch('actionPushNotification', {message})
    },
    actionPushErrorMessage(ctx, message) {
      ctx.dispatch('actionPushNotification', {message, status: STATUS_ERROR})
    },
    actionPushNotification(ctx, {message = '', status = STATUS_MESSAGE}) {
      if (!message) return
      if (!ctx.getters.getNotificationStatuses.includes(status)) {
        status = STATUS_MESSAGE
      }
      let notification = {
        id: ctx.getters.getNotificationId,
        visible: true,
        message: message,
        type: status,
      }
      ctx.commit('mutationNotificationId')
      ctx.commit('mutationPushNotifications', notification)
      setTimeout(() => {
        ctx.dispatch('actionRemoveNotification', notification)
      }, NOTIFY_DURATION)
    },
    actionRemoveNotification(ctx, notification) {
      if (!notification) return;
      notification.visible = false
      setTimeout(() => {
        ctx.commit('mutationRemoveNotificationId', notification.id)
      }, NOTIFY_ANIMATION_DURATION)
    },
    actionChangeNotifications: (ctx, list = []) => ctx.commit('mutationChangeNotifications', list)
  },
  mutations: {
    mutationPushNotifications: (state, obj = {}) => {
      state.notifications.push(obj)
    },
    mutationNotificationId: (state) => {
      state.notification_id++
    },
    mutationRemoveNotificationId: (state, id) => {
      state.notifications = state.notifications.filter(notification => notification.id !== id)
    },
    mutationChangeNotifications: (state, list = []) => state.notifications = list
  },
  state: {
    notifications: [],
    notification_id: 1
  },
  getters: {
    getNotifications: state => state.notifications,
    getNotificationId: state => state.notification_id,
    getNotificationStatuses: () => [STATUS_ERROR, STATUS_MESSAGE, STATUS_WARNING, STATUS_SUCCESS]
  }
}
